angular.module("tromanWeb").controller('OrganizationTypeEditController', ['DialogControllerBase', '$scope', 'tromanServer', 'organizationType', function (DialogControllerBase, $scope, tromanServer, organizationType) {

    var self = this;
    DialogControllerBase.call(self, tromanServer.OrganizationTypes, $scope);

    self.getTitle = function () { return 'organisationstypen "' + self.organizationType.Name + '"'; };
    self.getItem = function () { return self.organizationType; };

    self.loadItem(organizationType).then(function (data) {
        self.organizationType = data;
    });

}]);
